import React, { useEffect } from "react";
import { Fragment, useState } from "react";
import {
  Row,
  Col,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
} from "reactstrap";
import {
  Close,
  location,
  addressName,
  localArea,
  village,
  taluka,
  district,
  state,
  country,
  zipCode,
  Save,
  blockName,
} from "../../../../constant";
import { useForm } from "react-hook-form";
import jwtDecode from "jwt-decode";
import { createBlock, getPlantListData } from "../../../../api";
import { toast } from "react-toastify";

const AddBlockModal = ({
  showModal,
  setShowModal,
  Modaltoggle,
  setRefetch,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [plantData, setPlantData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadPlantData = async () => {
    let data = await getPlantListData();
    setPlantData(data.data.data || []);
  };

  const loadData = async () => {
    loadPlantData();
  };

  useEffect(() => {
    loadData();
  }, []);

  const onSubmit = async (data) => {
    setIsLoading(true);
    const {
      blockName,
      plantId,
      addressName,
      localArea,
      village,
      taluka,
      district,
      state,
      country,
      zipCode,
    } = data;

    try {
      const userToken = localStorage.getItem("token");
      let decodedUser = jwtDecode(userToken);

      const payload = {
        name: blockName,
        plant_id: plantId,
        user_id: decodedUser.id,
        address: {
          location: {
            type: "Point",
            coordinates: [],
          },
          name: addressName,
          local_area: localArea,
          village: village,
          taluka: taluka,
          district: district,
          state: state,
          country: country,
          pincode: zipCode,
          raw_address: `${addressName}, ${localArea}, ${village}, ${taluka}, ${district}, ${state}, ${country}, ${zipCode}`,
        },
      };

      const block = await createBlock(payload);
      setRefetch(true);
      toast.success("Block added successfully!");
      setIsLoading(false);
      setShowModal(false);

      reset();
    } catch (error) {
      console.log(error);
      setShowModal(false);
      setIsLoading(false);
      toast.error(error.message);
    }
  };

  const plantListOptions = plantData.map((item, index) => {
    return (
      <option value={item?._id} key={index}>
        {item?.name}
      </option>
    );
  });

  return (
    <Fragment>
      <Modal isOpen={showModal} toggle={Modaltoggle} size="xl">
        <Form
          className="needs-validation"
          noValidate=""
          onSubmit={handleSubmit(onSubmit)}
        >
          <ModalHeader toggle={Modaltoggle}>{"Block Details"}</ModalHeader>
          <ModalBody>
            <CardBody>
              <Row>
                <Col md="6 mb-3">
                  <Label htmlFor="validationCustom01">{blockName}</Label>
                  <input
                    className="form-control"
                    name="blockName"
                    type="text"
                    placeholder="Block Name"
                    {...register("blockName", { required: true })}
                  />
                  <span>{errors.plantName && "Block name is required"}</span>
                  <div className="valid-feedback">
                    {"Block Name is required"}
                  </div>
                </Col>
                <Col md="6 mb-3">
                  <Label htmlFor="validationCustom01">Plant</Label>
                  <select
                    className="form-control"
                    name="plantId"
                    {...register("plantId", { required: true })}
                  >
                    <option value={null}>Select Plant</option>
                    {plantListOptions}
                  </select>
                  <span>{errors.plantName && "Block name is required"}</span>
                  <div className="valid-feedback">
                    {"Block Name is required"}
                  </div>
                </Col>
              </Row>

              <Row>
                <h5>Block Address Details</h5>
                {/* location coordinates */}
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">{location}</Label>
                  <input
                    className="form-control"
                    name="location"
                    type="text"
                    placeholder="Location"
                    {...register("location", { required: true })}
                  />
                  <span>
                    {errors.location && "Please provide location coordinates"}
                  </span>
                  <div className="invalid-feedback">
                    {"Please provide location coordinates."}
                  </div>
                </Col>
                {/* address Name */}
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom04">{addressName}</Label>
                  <input
                    className="form-control"
                    id="validationCustom04"
                    name="addressName"
                    type="text"
                    placeholder="Address Name"
                    {...register("addressName", { required: true })}
                  />
                  <span>
                    {errors.addressName && "Please Provide Address Name"}
                  </span>
                  <div className="invalid-feedback">
                    {"Please provide a Address Name"}
                  </div>
                </Col>
                {/* local area */}
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom05">{localArea}</Label>
                  <input
                    className="form-control"
                    id="validationCustom05"
                    name="localArea"
                    type="text"
                    placeholder="Local Area"
                    {...register("localArea", { required: true })}
                  />
                  <span>
                    {errors.localArea && "Please provide a Local Area."}
                  </span>
                  <div className="invalid-feedback">
                    {"Please provide a Local Area."}
                  </div>
                </Col>
              </Row>
              <Row>
                {/* village */}
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">{village}</Label>
                  <input
                    className="form-control"
                    name="village"
                    type="text"
                    placeholder="Village"
                    {...register("village", { required: true })}
                  />
                  <span>
                    {errors.location && "Please provide a Village Details"}
                  </span>
                  <div className="invalid-feedback">
                    {"Please provide a Village Details"}
                  </div>
                </Col>
                {/* taluka */}
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom04">{taluka}</Label>
                  <input
                    className="form-control"
                    id="validationCustom04"
                    name="taluka"
                    type="text"
                    placeholder="Taluka"
                    {...register("taluka", { required: true })}
                  />
                  <span>
                    {errors.addressName && "Please Provide taluka details"}
                  </span>
                  <div className="invalid-feedback">
                    {"Please provide taluka details"}
                  </div>
                </Col>
                {/* district*/}
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom05">{district}</Label>
                  <input
                    className="form-control"
                    id="validationCustom05"
                    name="district"
                    type="text"
                    placeholder="District"
                    {...register("district", { required: true })}
                  />
                  <span>
                    {errors.district && "Please provide a District Name"}
                  </span>
                  <div className="invalid-feedback">
                    {"Please provide a District Name."}
                  </div>
                </Col>
              </Row>
              <Row>
                {/* State */}
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">{state}</Label>
                  <input
                    className="form-control"
                    name="state"
                    type="text"
                    placeholder="State"
                    {...register("state", { required: true })}
                  />
                  <span>
                    {errors.State && "Please provide a State Details"}
                  </span>
                  <div className="invalid-feedback">
                    {"Please provide a State Details"}
                  </div>
                </Col>
                {/* Country */}
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom04">{country}</Label>
                  <input
                    className="form-control"
                    id="validationCustom04"
                    name="country"
                    type="text"
                    placeholder="Country"
                    {...register("country", { required: true })}
                  />
                  <span>
                    {errors.country && "Please Provide a Country name"}
                  </span>
                  <div className="invalid-feedback">
                    {"Please provide a country name"}
                  </div>
                </Col>
                {/* pincode/zipcode*/}
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom05">{zipCode}</Label>
                  <input
                    className="form-control"
                    id="validationCustom05"
                    name="zipCode"
                    type="text"
                    placeholder="Zip Code"
                    {...register("zipCode", { required: true })}
                  />
                  <span>{errors.zipCode && "Please provide a zip code"}</span>
                  <div className="invalid-feedback">
                    {"Please provide a zipcode/Pincode."}
                  </div>
                </Col>
              </Row>
              <FormGroup>
                <div className="form-check"></div>
              </FormGroup>
              {/* <Button color="primary">{"Submit form"}</Button> */}
            </CardBody>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={Modaltoggle}>
              {Close}
            </Button>
            <Button
              style={isLoading ? { cursor: "not-allowed" } : {}}
              className={isLoading && `disabled`}
              color="primary"
              type="submit"
            >
              {isLoading ? "Submitting..." : "Submit"}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default AddBlockModal;
